import FleetPlus from './FleetPlus';
import FleetPartners from './FleetPartners';

export default {
  FleetPlus,
  FleetPartners
};



// WEBPACK FOOTER //
// ./src/themes/themes/iframes/index.js